export const RESEND = 'resend';
export const DELETE = 'delete';

export const RESEND_LABEL = 'Resend request';
export const DELETE_LABEL = 'Delete request';

function getActionsByStatus(withResend) {
    let result = [{
        key: DELETE,
        text: DELETE_LABEL,
        icon: 'Trash'
    }];
    if (withResend) {
        result.push({
            key: RESEND,
            text: RESEND_LABEL,
            icon: 'RefreshCw'
        });
    }
    return result;
}

export {getActionsByStatus}
